<template lang="pug">
div
    .box
        .box-header.dker
            h3
                span(v-if="!hasFinalized") Stock Return - Step 2 of 3
                span(v-else) Stock Return - Step 3 of 3

        .box-divider.m-a-0.p-a-0

        .box-body
            .p-a
                step-wizard(:status="stockReturn.status")

        .box-header
            h3 General

        .box-divider.m-a-0.p-a-0

        .box-body
            .row
                .col-sm-6
                    table.table.table-borderless
                        tr
                            td._500 Reference Id
                            td {{ stockReturn.reference_id }}

                        tr
                            td._500 Name
                            td
                                .form-group
                                    input.form-control.w-lg(
                                        :class="{ 'has-error': errors.has('name') }"
                                        v-show="canEdit",
                                        type="text",
                                        name="name",
                                        v-validate="'required'",
                                        :value="stockReturn.name",
                                        @input="setStockReturnAttr({ key: 'name', value: $event.target.value })"
                                    )

                                span(v-show="!canEdit") {{ stockReturn.name }}

                        tr
                            td._500 Status
                            td
                                span.label.hidden-print(
                                    :class="{'yellow': ! hasFinalized, 'success': hasFinalized}"
                                )
                                    strong {{  completionStatus }}

                .col-sm-6
                    table.table.table-form-input
                        tr
                            td._500 Return Date
                            td
                                vue-datepicker(
                                    v-show="canEdit",
                                    type="datetime"
                                    v-model="returnDate",
                                    lang="en",
                                    :editable="false",
                                    :clearable="false",
                                    :shortcuts="false",
                                    format="DD/MM/YYYY hh:mm:ss a"
                                    :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                )
                                span(v-show="!canEdit") {{ formattedDate(returnDate) }}

                        tr
                            td._500 Return From
                            td {{ outlet.name }}

                        tr
                            td._500 Supplier
                            td {{ supplier.name }}

                        tr
                            td._500 General Notes
                            td
                                textarea.form-control(
                                    rows="3",
                                    :value="stockReturn.description",
                                    v-if="canEdit",
                                    @input="setStockReturnAttr({ key: 'description', value: $event.target.value })"
                                )
                                span(v-else) {{ stockReturn.description }}

</template>

<script>
import stockReturnMixin from './stock-return-mixin';
import { mapGetters, mapState, mapActions } from 'vuex';
import stepWizard from './stock-return-step.vue';

export default {
    inject: ['$validator'],

    components: { stepWizard },

    mixins: [stockReturnMixin],

    computed: {
        ...mapState('stockReturn', ['stockReturn']),

        ...mapGetters('stockReturn', [
            'outlet',
            'stockReturn',
            'supplier',
            'completionStatus',
        ]),

        returnDate: {
            get() {
                return this.stockReturn.return_date;
            },
            set(datetime) {
                const value = moment(datetime).format();
                this.setStockReturnAttr({ key: 'return_date', value });
            },
        },
    },

    methods: {
        ...mapActions('stockReturn', ['setStockReturnAttr']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-edit-info.vue